/*

  t a l k
  Talk

  :description:
  Our wrapped logging function.

*/

//
//  :statics:
export const EYEKANDY_TALK_FUNCTION_WINDOW_KEY = 'ekyTalk'

/**
 * Our wrapped logging function.
 * @param {Array} args The arguments to log, can also be a single object.
 * @param {String} [level=log] The logging level to use.
 * @param {Boolean} [force=false] A boolean to force the log.
 * @param {String} [uuid] The UUID to use in the output string.
 */
export const talk = (args, level, force, uuid) => {
  if (!level) {
    level = 'log'
  }
  const levelToFunctionMap = {
    log: console.log,
    info: console.info,
    warning: console.warn,
    error: console.error
  }
  const loggingFunction = levelToFunctionMap[level]
  if (!loggingFunction) {
    throw new Error(`error, unknown logging level '${level}'`)
  }

  //
  //  See if we are silenced by the our core or the legacy key.
  let silence = false
  if (typeof window !== 'undefined') {
    silence = window.EYEKANDY_APP_CORE
      ? !window.EYEKANDY_APP_CORE.readBrowserConfig('console')
      : window.location.href.indexOf('eky-logging') === -1
  }

  //
  //  We need to unpack dynamically so ensure we have a list as our args.
  if (!Array.isArray(args)) {
    args = [args]
  }

  //
  //  If we are not silent, or have been instructed to force the message, write to console.
  if (!silence || force) {
    var event = new Date()
    const timeAsString = event.toTimeString().split(' ')[0]
    let tidyTimeString = `[${timeAsString}.${event.getMilliseconds()}]`
    if (uuid) {
      tidyTimeString = `${tidyTimeString} {${uuid}}\n `
    }
    loggingFunction(tidyTimeString, ...args)
    return true
  }
  return false
}
